import {route, string, union} from 'react-router-typesafe-routes';

export const practiceRoutesPath = route({
  children: {
    cloneProgram: route({
      path: 'program/clone/:clonedProgramId',
    }),
    coachPractice: route({
      children: {
        program: route({
          children: {
            course: route({
              children: {
                goals: route({
                  path: 'goals',
                }),
              },
              path: ':courseId',
              searchParams: {
                pid: string(),
                sqid: string(),
              },
              state: {
                tab: union([
                  'clients',
                  'coaches',
                  'invites',
                  'members',
                  'payments',
                ]),
              },
            }),
          },
          path: ':programSlugOrId',
          state: {
            tab: union(['requests']),
          },
        }),
      },
      path: 'coaches/:practiceSlugOrId',
    }),
    createProgram: route({
      path: 'program',
    }),
    editProgram: route({
      path: 'program/:programId',
    }),
  },
});
